export default "__VITE_ASSET__B6xR3Gow__"